var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4434_3547",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4434_3547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7 15.75L9.975 11.025C9.6 11.325 9.16875 11.5625 8.68125 11.7375C8.19375 11.9125 7.675 12 7.125 12C5.7625 12 4.6095 11.5282 3.666 10.5848C2.722 9.64075 2.25 8.4875 2.25 7.125C2.25 5.7625 2.722 4.60925 3.666 3.66525C4.6095 2.72175 5.7625 2.25 7.125 2.25C8.4875 2.25 9.64075 2.72175 10.5848 3.66525C11.5282 4.60925 12 5.7625 12 7.125C12 7.675 11.9125 8.19375 11.7375 8.68125C11.5625 9.16875 11.325 9.6 11.025 9.975L15.75 14.7L14.7 15.75ZM7.125 10.5C8.0625 10.5 8.8595 10.172 9.516 9.516C10.172 8.8595 10.5 8.0625 10.5 7.125C10.5 6.1875 10.172 5.3905 9.516 4.734C8.8595 4.078 8.0625 3.75 7.125 3.75C6.1875 3.75 5.3905 4.078 4.734 4.734C4.078 5.3905 3.75 6.1875 3.75 7.125C3.75 8.0625 4.078 8.8595 4.734 9.516C5.3905 10.172 6.1875 10.5 7.125 10.5Z",
    fill: "#F6F6F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/search2.c1dea563be61d01334a510367b424998.svg";
export { ForwardRef as ReactComponent };